import { render, staticRenderFns } from "./dshxq.vue?vue&type=template&id=4dc41565"
import script from "./dshxq.vue?vue&type=script&lang=js"
export * from "./dshxq.vue?vue&type=script&lang=js"
import style0 from "./dshxq.vue?vue&type=style&index=0&id=4dc41565&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports